// extracted by mini-css-extract-plugin
export default {"component":"PendingButtonStyles_component__iAs+K","text":"PendingButtonStyles_text__u1TGV"};